/*
 Dependencies
 */

import {Module} from "wrapper6";
import {debounce} from "./../_utils";

var $ = jQuery;

export default class CalendarModule extends Module {

	boot() {

		if ($('.so-widget-mtt-event-calendar').length === 0 && $('.so-widget-mtt-event-calendar-grid').length === 0) {
			return false;
		}

		this.pageStore = $('[data-page]');
		this.pageNumberElement = $('.week_number');

		this.page = parseInt(this.pageStore.attr('data-page'));
		this.filter = 'all';

		this.maxPageStore = $('[data-total-pages]');
		this.maxPage = parseInt(this.maxPageStore.attr('data-total-pages'));

		this.adjustButtons();

		this.debounceFetchEvents = debounce(500, this.fetchEvents);

		this.dom = {};

		this.dom.detailsWrapper = $('.event_details');
		this.dom.urlDetail = $('#event-url');
		this.dom.titleDetail = this.dom.detailsWrapper.find('#event-title');
		this.dom.textDetail = this.dom.detailsWrapper.find('#event-text');
		this.dom.locationDetail = this.dom.detailsWrapper.find('.location');
		this.dom.priceDetail = this.dom.detailsWrapper.find('.price');
		this.dom.dateDetail = this.dom.detailsWrapper.find('.date');

	}

	ready(app) {

		var _ = this;

		this.loadFirstEvent();

		$(document).on('click', '.mtt-event-calendar input[name=filtering]', function () {
			_.adjustPage(1, true);
		});

		$(document).on('click', '.active.week_next', function () {
			_.adjustPage(1);
		});

		$(document).on('click', '.active.week_prev', function () {
			_.adjustPage(-1);
		});

		$(document).on('mouseover', '.events .event', function () {
			_.loadEvent($(this));
		});

		if ($('input[name="has-featured-event"]').val() === 'true') {
			$(document).on('mouseout', '.events .event', function () {
				_.loadEvent($('.featured_event'));
			});
		}

	}

	getFilter() {
		let val = jQuery('.mtt-event-calendar input[name=filtering]:checked').val();
		return (typeof val === 'string') ? val : 'all';
	}

	getTag() {
		return $('[data-tag]').data('tag') || null;
	}

	adjustPage(adjustment, reset = false) {
		$('.loader_overlay').addClass('is-loading');

		if (reset) {
			this.page = 1;
		} else {
			this.page += adjustment;
		}

		this.normalizePage();
		this.adjustButtons();
		this.pageStore.attr('data-page', this.page);
		this.pageNumberElement.text(this.page);
		this.debounceFetchEvents();
	}

	adjustButtons() {
		if (this.page <= 1) {
			$('.week_prev').removeClass('active');
		} else {
			$('.week_prev').addClass('active');
		}
		if (this.page >= this.maxPage) {
			$('.week_next').removeClass('active');
		} else {
			$('.week_next').addClass('active');
		}
	}

	fetchEvents() {
		var _ = this;

		var data = {
			action: 'fetch_events',
			page: this.page,
			filter: this.getFilter(),
			tag: this.getTag(),
		};

		jQuery.post(ajax_object.ajax_url, data, function (response) {
			$('.events').replaceWith(response.html);

			_.maxPageStore.attr('data-total-pages', response.pages);
			_.maxPage = response.pages;

			_.adjustButtons();

			_.loadFirstEvent();
			$('.loader_overlay').removeClass('is-loading');
		});

	}

	loadFirstEvent() {
		if ($('input[name="has-featured-event"]').val() === 'true') {
			this.loadEvent($('.featured_event'));
		} else {
			this.loadEvent($('.events .event').first());
		}
	}

	loadEvent(event) {
		var eventID = event.attr('data-id');
		this.dom.urlDetail.attr('href', event.find('input[name="url"]').val());
		this.dom.titleDetail.html(event.find('input[name="title"]').val());
		this.dom.textDetail.html(event.find('input[name="text"]').val());
		this.dom.locationDetail.html(event.find('input[name="location"]').val());
		this.dom.priceDetail.html(event.find('input[name="price"]').val());
		this.dom.dateDetail.find('.the_date').html(event.find('input[name="date"]').val());
		this.dom.dateDetail.find('.time_from').html(event.find('input[name="time_from"]').val());
		this.dom.dateDetail.find('.time_to').html(event.find('input[name="time_to"]').val());

		var background = event.find('input[name="image"]').val();
		if (background !== '') {
			this.dom.detailsWrapper.css('background-image', "url('" + background + "')");
		} else {
			this.dom.detailsWrapper.css('background-image', "");
		}

		$('.events .event').removeClass('is_active');
		$('.events').find('li[data-id="' + eventID + '"]').addClass('is_active');
	}

	normalizePage() {
		if (this.page < 1) {
			this.page = 1;
		} else if (this.page > this.maxPage) {
			this.page = 1;
		}
	}

}